export function buildMonthlySkeleton() {
  const months = [];
  const now = new Date();
  for (let i = 5; i >= 0; i -= 1) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
    months.push({
      month: date.toLocaleDateString("en-US", { month: "short", year: "numeric" }),
      revenue: 0,
    });
  }
  return months;
}

/** Normalize API monthly revenue for charts (fallback when orders are not linked yet). */
export function normalizeChartMonths(monthlyRevenue, totalRevenue = 0) {
  const base =
    Array.isArray(monthlyRevenue) && monthlyRevenue.length > 0
      ? monthlyRevenue
      : buildMonthlySkeleton();
  const hasOrderData = base.some((month) => Number(month.revenue) > 0);

  if (!hasOrderData && Number(totalRevenue) > 0) {
    const copy = base.map((month) => ({ ...month }));
    copy[copy.length - 1] = {
      ...copy[copy.length - 1],
      revenue: totalRevenue,
    };
    return copy;
  }

  return base;
}

export function hasRevenueChartData(chartMonths, totalRevenue = 0) {
  return (
    chartMonths.some((month) => Number(month.revenue) > 0) ||
    Number(totalRevenue) > 0
  );
}

export function chartMonthKey(chartMonths) {
  return chartMonths.map((m) => `${m.month}-${m.revenue}`).join("|");
}
